module.exports = __webpack_public_path__ + "media/images/icon__arrow-left@3x-97eb2fb86abf7e284105ceaff6afd15b.png";